'use client';

import React, { useEffect, useRef, useState } from 'react';

const doctorImages = [
{
  src: 'https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=800&q=80',
  alt: 'Dr. A. Mitchell, D.M.D.'
},
{
  src: 'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=800&q=80',
  alt: 'Dr. S. Reynolds, D.D.S.'
}];


export default function DoctorImages() {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );
    if (ref?.current) observer?.observe(ref?.current);
    return () => observer?.disconnect();
  }, []);

  return (
    <div data-component-id="src/components/DoctorImages.tsx:35:4" data-component-path="src/components/DoctorImages.tsx" data-component-line="35" data-component-end-line="55" data-component-file="DoctorImages.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20grid%20grid-cols-1%20md%3Agrid-cols-2%22%7D" ref={ref} className="w-full grid grid-cols-1 md:grid-cols-2">
      {doctorImages?.map((img, idx) =>
      <div data-component-id="src/components/DoctorImages.tsx:37:6" data-component-path="src/components/DoctorImages.tsx" data-component-line="37" data-component-end-line="53" data-component-file="DoctorImages.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
        key={idx}
        className={`img-overlay relative overflow-hidden transition-all duration-700 ${
        isVisible ? 'opacity-100' : 'opacity-0'}`
        }
        style={{
          transitionDelay: `${idx * 200}ms`,
          height: '500px'
        }}>
        
          <img data-component-id="src/components/DoctorImages.tsx:47:10" data-component-path="src/components/DoctorImages.tsx" data-component-line="47" data-component-end-line="51" data-component-file="DoctorImages.tsx" data-component-name="img" data-component-content="%7B%22elementName%22%3A%22img%22%2C%22className%22%3A%22w-full%20h-full%20object-cover%20transition-transform%20duration-700%20hover%3Ascale-105%22%7D"
          src={img?.src}
          alt={img?.alt}
          className="w-full h-full object-cover transition-transform duration-700 hover:scale-105"
          loading="lazy" />
        
        </div>
      )}
    </div>);

}